import React, { useEffect, useState } from 'react';
import { Container, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import { get, post } from '../../../../services/back.service';
import LoadingSpinner from '../../../shared/loaderSpinner';
import useAutosave from '../../../../hooks/useAutosave';

function FormCompCushions({ id }) {
  const [isLoading, setIsLoading] = useState(false);
  const [msgButton, setMsgButton] =useState('Guardar Informacion')
  const [infoCushions, setInfoCompCushions] = useState({
    Cloth_Seats: 0,
    Cloth_Ceilings: 0,
    Millaret: 0,
    Center_console: 0,
    wallets: 0,
    Floor_Carpet: 0,
    Belts: 0,
    Glove_box: 0,
    sun_visors: 0,
    Air_Grilles: 0,
  });
  const [states, setStates] = useState([]);

  const autosave = useAutosave(async () => {
    await post('/peritaje/modifyinspection/components/' + id, { type: 'CC', data: infoCushions });
  });

  const handleForm = ({ target }) => {
    const tmpinfoCushions = { ...infoCushions, [target.name]: target.value }
    setInfoCompCushions(tmpinfoCushions);
    autosave.schedule();
    //generalUpdate('infoCushions', tmpinfoCushions)
  };

  const getInfoState = async () => { //infostate
    const respoInfo = await get( `/peritaje/infostate/C` ,  {});
    if (respoInfo.success) {
      const { stateapp } = respoInfo.data;
      const currentDefaultState = stateapp.find((e)=> e.name.toLowerCase()==='bueno')
      setInfoCompCushions({
        Cloth_Seats:currentDefaultState.id,
        Cloth_Ceilings:currentDefaultState.id,
        Millaret:currentDefaultState.id,
        Center_console:currentDefaultState.id,
        wallets:currentDefaultState.id,
        Floor_Carpet:currentDefaultState.id,
        Belts:currentDefaultState.id,
        Glove_box:currentDefaultState.id,
        sun_visors:currentDefaultState.id,
        Air_Grilles:currentDefaultState.id,
      });
      setStates(stateapp);
    } else {
      console.log(respoInfo.message);
    }
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    const body = {type:'CC', data :infoCushions};
    const respo = await post('/peritaje/modifyinspection/components/'+id, body);
    if(respo.success){
      setMsgButton('Actualizar')
    }
  };
  useEffect(() => {
    const initForm = async () => {
      setIsLoading(true);
      const body = { type: 'CC' };
      const tmpCushions = {};
      const respo = await post(
        '/peritaje/infodetailinspection/components/' + id,
        body,
      );
      if (respo.success) {
        const {detail} = respo.data;
        for (let i = 0; i < detail.length; i++) {
          const element = detail[i];
          tmpCushions[element.name] = element.id_state;
        }
        if(detail.length>0) setInfoCompCushions(tmpCushions);
      }
      setIsLoading(false);
    };
    getInfoState();
    initForm();
  }, [id]);

  return (isLoading) ? <LoadingSpinner />  : (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">COJINERIAS</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Cloth_Seats">Paño Asientos</Form.Label>
          <Form.Select
            name="Cloth_Seats"
            value={infoCushions.Cloth_Seats}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Cloth_Ceilings">Paño Techos</Form.Label>
          <Form.Select
            name="Cloth_Ceilings"
            value={infoCushions.Cloth_Ceilings}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Millaret">Millaret</Form.Label>
          <Form.Select
            name="Millaret"
            value={infoCushions.Millaret}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Center_console">Consola Central</Form.Label>
          <Form.Select
            name="Center_console"
            value={infoCushions.Center_console}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="wallets">Carteras</Form.Label>
          <Form.Select
            name="wallets"
            value={infoCushions.wallets}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Floor_Carpet">Piso Alfombra</Form.Label>
          <Form.Select
            name="Floor_Carpet"
            value={infoCushions.Floor_Carpet}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Belts">Cinturones</Form.Label>
          <Form.Select
            name="Belts"
            value={infoCushions.Belts}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Glove_box">Guantera</Form.Label>
          <Form.Select
            name="Glove_box"
            value={infoCushions.Glove_box}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="sun_visors">Parasoles</Form.Label>
          <Form.Select
            name="sun_visors"
            value={infoCushions.sun_visors}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Air_Grilles">Rejillas Aire</Form.Label>
          <Form.Select
            name="Air_Grilles"
            value={infoCushions.Air_Grilles}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
          {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormCompCushions;
